/* @jsxImportSource @emotion/react */
import React from 'react'

// The ⌘K / Ctrl K hint. Rendered only after mount on pointer devices: the label
// depends on the visitor's platform, and it's noise on touch (and during SSR).
export function HelpSearchTrigger() {
  const [label, setLabel] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) {
      return
    }
    const isApplePlatform = /Mac|iPhone|iPad/.test(window.navigator.platform)
    setLabel(isApplePlatform ? '⌘K' : 'Ctrl K')
  }, [])

  if (!label) {
    return null
  }

  return (
    <kbd
      className="shade-30 flexbox-no-shrink font-size-8"
      css={{
        fontFamily: 'inherit',
        fontWeight: 600,
        lineHeight: '16px',
        padding: '1px 5px',
        borderRadius: 6,
        border: '1px solid var(--shade-45)',
        background: 'var(--shade-60)',
      }}
    >
      {label}
    </kbd>
  )
}
